$(function () {
	
    window.addEventListener("load", function () {
        // Set a timeout...
        setTimeout(function () {
            // Hide the address bar!
            window.scrollTo(0, 1);
        }, 0);
    });
    
     // Log Call Button Click
    $(".callmenuLink").on("click", function (e) {
    	  metricsLogCallButtonClick("Call Button Header");
    });
    $(".footerlinkMiddle").on("click", function (e) {
    	  metricsLogCallButtonClick("Call Button Footer");
    });
    
    $("#searchText").keyup(function(event){
	    if(event.keyCode == 13){
	        $("#searchBtn").click();
	    }
    });

    $('#quicklinks h2').click(function () {
        if ($('#quicklinks h2 span').hasClass('plusSign')) {
            $('#quicklinks h2 span.icon').removeClass('plusSign');
            $('#quicklinks h2 span.icon').addClass('minusSign');
        } else {
            $('#quicklinks h2 span.icon').removeClass('minusSign');
            $('#quicklinks h2 span.icon').addClass('plusSign');
        }
        $('#quicklinks ul').toggle();
    });

    $('#boutiques h2').click(function () {
        if ($('#boutiques h2 span').hasClass('plusSign')) {
            $('#boutiques h2 span.icon').removeClass('plusSign');
            $('#boutiques h2 span.icon').addClass('minusSign');
        } else {
            $('#boutiques h2 span.icon').removeClass('minusSign');
            $('#boutiques h2 span.icon').addClass('plusSign');
        }
        $('#boutiques ul').toggle();
    });
    
    $('#hottestsearches h2').click(function () {
        if ($('#hottestsearches h2 span').hasClass('plusSign')) {
            $('#hottestsearches h2 span.icon').removeClass('plusSign');
            $('#hottestsearches h2 span.icon').addClass('minusSign');
        } else {
            $('#hottestsearches h2 span.icon').removeClass('minusSign');
            $('#hottestsearches h2 span.icon').addClass('plusSign');
        }
        $('#hottestsearches ul').toggle();
    });

    $('.mobilefooter').on('click touch', '#lnkMainSiteLink', function (e) {
        e.preventDefault();
        var url = $(this).attr('data-url');
        $.post("/homemobile/RedirectToMainSite", { url: url } );
    });

    $("#searchBtn").click(function () {
        search();
    });

    $(".listSortBy").click(function () {
        $(".listSortOptions").toggle();
    });
    
    function search() {
        var searchTerm = $('#searchText').val();
        var url = window.location.href.replace((window.location.pathname+window.location.search).substring(1), '');
        if (url.indexOf('https://') !== -1) {
            url = url.replace('https://', 'http://');
            if (url.endsWith('/')) {
                url = url.substring(0, url.length - 1);
            }
            url = url + "/search/" + searchTerm;
            if (searchTerm.trim() != '') {
                location.href = url;
            }
        } else {
            if (searchTerm.trim() != '') {
                window.location = "/search/" + searchTerm;
            }
        }

    }

    function showImage(width, largeImageControlId, imageUrl, height) {
        $("#" + largeImageControlId).attr("src", imageUrl);
        $("#" + largeImageControlId).attr("height", height);
        $("#" + largeImageControlId).attr("width", width);
        $("#resizeImageContainer").show("slow");
    }

    $(".productInfo").on("click", "#resizeImageContainerClose", function () {
        $("#resizeImageContainer").hide("fast");
    });

    $(".productInfo").on("click", ".resizeImage", function (e) {
        e.preventDefault();
        var imgUrl = e.currentTarget.href.toString();
        $("#detailsImage").attr("src", imgUrl);
        $("#resizeImageContainer").show("slow");
    });

    $(".productInfo").on("click", ".showImage", function (e) {
        e.preventDefault();
        var imgUrl = e.currentTarget.href.toString();
        $("#detailImage").attr("src", imgUrl);
    });

    $('.colorGroup').on('click', function (e) {
        $('.colorGroup').removeClass('selectedColorBox');
        $(this).addClass('selectedColorBox');

        $('#selectedColor').attr('data-base', $(this).attr('data-base'));
        $('#selectedColor').attr('data-trim', $(this).attr('data-trim'));
    });

    //details and reviews panels on product detail page
    $("#accordion").accordion({
        collapsible: true, heightStyle: "content",
        		icons: {
			activeHeader: "icon icon-arrowUp floatRight",
			header: "icon icon-arrowDown floatRight"
		},
     	
    });


    $('.invitationSubmit').on('click', function () {
        var invitationCode = $('.invitationCode').val();
        location.href = '/survey/' + invitationCode;
    });

    $('.submitSurveyBtn').on('click', function (e) {
	e.preventDefault();
        var valid = true;
        var easeRating = $('#ease').rateit('value');
        var recoRating = $('#recommend').rateit('value');
        var feedback = $('#feedback').val();
        var orderID = $('#orderID').val();

        // build json string for each product review.
        var jsonString = '[';
        $('.singleItemReview').each(function () {
            jsonString += '{';
            jsonString += '"catAlias":"' + $(this).find('.itemCatAlias').val() + '",';
            jsonString += '"itemRating":"' + $(this).find('.rateit').rateit('value') + '",';
            jsonString += '"itemReview":"' + $(this).find('.itemReview').val() + '",';
            jsonString += '"itemImprovements":"' + $(this).find('.itemImprovements').val() + '"';
            if ($(this).find('.itemSizeBox').length !== 0) {
                jsonString += ',"itemSizeScore":"' + $(this).find('.itemSizeBox input[type="radio"]:checked').val() + '"';
                jsonString += ',"itemSizeComments":"' + $(this).find('.itemSizeComments').val() + '"';
            }
            jsonString += '},';
        });
        jsonString = jsonString.slice(0, -1);
        jsonString += ']';

        $.ajax({
            url: '/Survey/SubmitFeedback',
            type: 'POST',
            dataType: 'json',
            data: {
                easeRating: easeRating,
                recoRating: recoRating,
                feedback: feedback,
                orderID: orderID,
                itemReviews: jsonString
            },
            success: function (result) {
                window.location.assign(result.url);
            },
            error: function (xhr, status, error) {
                alert('Please make sure all fields are filled in.');
            }
        });

    });

    $('.justSurveyBtn').on('click', function (e) {
    	e.preventDefault();
        var valid = true;
        var easeRating = $('#ease').rateit('value');
        var recoRating = $('#recommend').rateit('value');
        var feedback = $('#feedback').val();
        var orderID = $('#orderID').val();

        if (easeRating.length < 1) { valid = false; $('#easeRatingError').removeClass("hide"); } else { $('#easeRatingError').addClass("hide"); }
        if (recoRating.length < 1) { valid = false; $('#recoRatingError').removeClass("hide"); } else { $('#recoRatingError').addClass("hide"); }

        if (valid == true) {
            $.ajax({
                url: '/Survey/SubmitFeedback',
                type: 'POST',
                dataType: 'json',
                data: {
                    easeRating: easeRating,
                    recoRating: recoRating,
                    feedback: feedback,
                    orderID: orderID,
                    itemReviews: 'false'
                },
                success: function (result) {
                    window.location.assign(result.url);
                },
                error: function (xhr, status, error) {
                    alert('Please make sure all fields are filled in.');
                }
            });
        }

    });

    $('#reviewProductBtn').on('click', function (e) {
    	e.preventDefault();
        var valid = true;

        var easeRating = $('#ease').rateit('value');
        var recoRating = $('#recommend').rateit('value');

        if (easeRating.length < 1) { valid = false; $('#easeRatingError').removeClass("hide"); } else { $('#easeRatingError').addClass("hide"); }
        if (recoRating.length < 1) { valid = false; $('#recoRatingError').removeClass("hide"); } else { $('#recoRatingError').addClass("hide"); }

        if (valid == true) {
            $('#twoSecondSurveyBox').slideUp();
            $('#reviewItemsBox').show();
        }
    });

});

// omniture metrics
function metricsLogCallButtonClick(buttonID) {
	var s=s_gi('4imprintmobile,4imprintprod'); 
	s.linkTrackVars='eVar27,events,prop14';
	s.linkTrackEvents='event24';
	s.eVar27=buttonID;
	s.events = 'event24'; 
	s.prop14= "Call Button";
	s.tl(this, 'o', 'Button Click');  
}

function IsNumeric(strString) {
    var strValidChars = "0123456789";
    var strChar;
    var blnResult = true;

    for (i = 0; i < strString.length && blnResult == true; i++) {
        strChar = strString.charAt(i);
        if (strValidChars.indexOf(strChar) == -1) {
            blnResult = false;
        }
    }
    return blnResult;
}
String.prototype.endsWith = function (suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};